import React, {  useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Logo from "../Logo";
import { FixedSizeList as List } from "react-window";
import { VenueViewCard } from "../ui/VenueViewCard";
import { InfoIconToolTip } from "../../yoello-lib/modules/components/UI/InfoIconToolTip/InfoIconToolTip";
import { useTranslation } from "react-i18next";
import { ANALYTICS_DASHBOARD_URL } from "../../const/URL.const";
import { OverviewSearch } from "./OverviewSearch";
import { SearchTypes, useVenueSearch } from "../../hooks/useVenueSearch";
import setRedirectURLs from "../../yoello-lib/modules/URL/setRedirectURLs"
import { Loading } from "../util/ListLoading";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    "& a": {
      color: theme.palette.text.secondary,
    },
    titleWrapper: {
      color: "#8D98B7",
      fontSize: 17,
      display: "flex",
      alignItems: "center",
      padding: "1rem 0 0 1rem"

    },
    title: {
      marginRight: 6
    },
    wrapper: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflow: "hidden",
      background:"linear-gradient(135deg, rgba(255, 255, 255, 0.35) 0%, #F3F4F9 100%)",
    },
    toolbar: { ...theme.mixins.toolbar, position: "relative" },
    logo: {
      height: "60px",
      position: "relative",
      marginBottom: "25px",
      "& .logo": {
        position: "absolute",
        left: "0",
        transform: "translate(0px, 8px) scale(0.8)",
        marginBottom: "12px",
      },
    },
    badge: {
      paddingTop: "12px",
    },
    list: {
      "&>div":{
        margin:"10px auto",
        width:"90%",
        padding:"1rem",
        "&>div>div":{
          padding:"0 1rem"
        }
      }
    },
    createBtn: {
      padding: "1rem 1rem 0.5rem 1rem"
    },
    noItems: {
      padding: "1rem",
      color: '#757575',
      fontSize: "1.05rem",
      textAlign: "center"
    },
    listLoadingItem:{
      borderRadius: "0.5rem!important",
      margin: "0 1.5625rem!important",
    }
  })
);

const AnalyticsDashboardSidebar = (props:any) => {
  const { t } = useTranslation();
  const [windowHeight] = useState(calculateListHeight());
  const classes = useStyles();
  const [searchText, setSearchText] = useState("");
  const [searchType, setSearchType] = useState(SearchTypes.VENUE_NAME);
  const { isLoading , venuesList} = useVenueSearch(searchText, searchType, props.isLoading);

  function Row({ index, style }: any) {
    const item = venuesList[index];
    return (
        <div style={style} key={index} data-component-name="CustomersItem">
            <VenueViewCard
              key={index}
              venue={item}
              venueId={item.serial_id}
              onClose={() => setRedirectURLs(ANALYTICS_DASHBOARD_URL)}
            />
        </div>
    );
  }
  return (
    <div className={classes.wrapper}>
      <div className={classes.toolbar}>
        <div className={classes.logo}>
          <Logo height="60px" />
        </div>
      </div>
      <div className={classes.titleWrapper}>
        <span className={classes.title}>
          {t("analytics.sidebar.title")}
        </span>
        <InfoIconToolTip infoMessage={"analytics.sidebar.tooltip"} />
      </div>
      <OverviewSearch setSearchText={setSearchText} isLoading={isLoading}
        selected={searchType} onSelected={setSearchType} />
      <div className={classes.list}>
      {venuesList?.length > 0 && !isLoading ? <List height={windowHeight}
            itemCount={venuesList.length}
            itemSize={143}
            width={"100%"}
            style={{
                paddingBottom: "15rem",
                overflow: "auto",
            }}
        >
            {Row}
        </List> : (isLoading || props.isLoading) ? <Loading className={classes.listLoadingItem}/> : <p className={classes.noItems}>
            {t('OverviewPage.OverviewSearch.emptyList')}
          </p>}
      </div>
    </div>
  );
};

/**calculates the list height */
function calculateListHeight() {
  const windowheight = window.innerHeight - 125;
  return windowheight;
}

export default AnalyticsDashboardSidebar;
